export default __webpack_public_path__ + "static/media/BecaMilano_Curso01_Banner_Full.fa51ac73.jpg";